// import './App.css'
import { useEffect } from 'react'
import { Header } from './components/Header/Header'
import { Routes, Route } from 'react-router-dom'
import { infoSite, ImgData, ImgYear } from './state/atom'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import Home from './views/Home/Index'
import { Setup } from './views/Setup/Index'
import { GetFirestore } from './api/controlers/controler'
import GetImgName from './views/Home/script/GetImgName'

import styled from 'styled-components'
import GlobalStyle from './style/GlobalStyle'
import PhotoStory from './views/PhotoStory'
import Footer from './components/Footer/Footer'
import ReactGA from 'react-ga';
import useGaTracker from './useGaTracker'

const Container = styled.div`
  text-align: center;
`

function App() {
  const InfoSite = useRecoilValue(infoSite)
  const setInfo = useSetRecoilState(infoSite)
  const setImages = useSetRecoilState(ImgData)
  const Year = useRecoilValue(ImgYear)
  useGaTracker();

  useEffect(() => {
    GetFirestore('Ziano', setInfo)
    GetImgName(setImages, Year)
    ReactGA.initialize('G-0S3YGZTPME');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [Year, setImages, setInfo])

  return (
    <Container className='App'>
      <GlobalStyle />
      <Header Name={InfoSite.Nome} Colore={InfoSite.Colore} iconaSito={InfoSite.iconaSito} Regione={InfoSite.Regione} />
      <Routes>
        <Route path='/' element={<PhotoStory />} />
        <Route path='/ziano' element={<Home />} />
        <Route path='setup' element={<Setup />} />
      </Routes>
      <Footer/>
    </Container>
  )
}

export default App
